
import Layout from '../layout/default';
import Block from '../components/Block/Block';
import DataTable from  '../components/DataTable/DataTable';
import { useEffect, useState, useRef } from "react";
import { Link, Route, Routes} from 'react-router-dom'
import { Navigate } from "react-router-dom";
import { MediaGroup, Media, MediaText, Image, Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating } from "../components";
import { Dropdown,Button,Breadcrumb } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import AddEditClient from '../components/Client/EditSections/AddEditClient';
import { useApiClient } from '../ApiService/useApiClient';

//const baseURL = SiteConfig.API_BASE_URL + "HMCareData/customerlist/";
const baseURL = "HMCareData/customerlist/";

// createTheme creates a new theme named solarized that overrides the build in dark theme
// createTheme('dark', {
//   text: {
//     primary: '#268bd2',
//     secondary: '#2aa198',
//   },
//   background: {
//     default: '#002b36',
//   },
//   context: {
//     background: '#cb4b16',
//     text: '#FFFFFF',
//   },
//   divider: {
//     default: '#073642',
//   },
//   action: {
//     button: 'rgba(0,0,0,.54)',
//     hover: 'rgba(0,0,0,.08)',
//     disabled: 'rgba(0,0,0,.12)',
//   }
// });

export const tableColumns = [    
    {
      name: "name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <MediaGroup>            
            <MediaText>
                <Link to={`/client/${row.customerid}`} className="title">{row.name}</Link>
            </MediaText>
        </MediaGroup>
        ),
    },
    {
        name: "Phone",
        selector: (row) => row.phone,
        sortable: true,
      },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      hide: "md",
    },
    {
      name: "Postcode",
      selector: (row) => row.postcode,
      sortable: true,
    },    
    {
      name: "action",      
      cell: (row) => (
        <div className="text-end w-100">
        <Dropdown>
            <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
                <Icon name="more-v"></Icon>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-sm" as={CustomDropdownMenu} align="end">
                <div className="dropdown-content py-1">
                    <LinkList className="link-list-hover-bg-primary link-list-md">
                        <LinkListItem to={`/client/${row.customerid}`}>
                            <Icon name="edit"></Icon><span>Details</span>
                        </LinkListItem>                                 
                    </LinkList>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    </div>
      ),
      sortable: false,      
  },
    
];

// expanded component in mobile view
const expandedComponent = ({ data }) => {
    return (
      <ul className="data-details p-3 gap gy-1 border-bottom small">
        <li>
          <span className="data-title text-base fw-medium me-2">Name:</span> 
          <span className="data-text text-light">{data.name}</span>
        </li>
        <li>
          <span className="data-title text-base fw-medium me-2">Phone:</span> 
          <span className="data-text text-light">{data.phone}</span>
        </li>
        <li>
          <span className="data-title text-base fw-medium me-2">Email:</span> 
          <span className="data-text text-light">{data.email}</span>
        </li>
        <li>
          <span className="data-title text-base fw-medium me-2">Postcode:</span> 
          <span className="data-text text-light">{data.postcode}</span>
        </li>        
      </ul>
    );
};


const Clients = () => {
  
   const api = useApiClient();

    const[data, setdata] = useState(null);  
    const[error, setError] = useState(null); 
    const dataFetchedRef = useRef(false);

    const[showAddEdit, setShowAddEdit] = useState(false);
  
    useEffect(()=>{

    

      if (dataFetchedRef.current) return;
      dataFetchedRef.current = true;

      setShowAddEdit(false);
            
      const fetchData = async () => {
        try {
          const response = await api.get(baseURL);
          setdata(response.data);
        } catch (err) {
          setError(err);
        }
      };
      fetchData();


          }, []);
    
        if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }
    
        if(!data) return (
          <Layout title="Clients" content="container"><Spinner animation="border" variant="primary" /></Layout>
          );;
     
          function openAddModal(){

        
            setShowAddEdit(true) ;
  
          }


  return (
    <>
    <Layout title="Clients" content="container"> 
    
    <Breadcrumb className="breadcrumb-arrow">
      <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>      
      <Breadcrumb.Item active>Client List</Breadcrumb.Item>
    </Breadcrumb>
         
    {/* <Block.Head page className="wide-md">
        <Block.HeadContent>
            <Block.Title>Client Management</Block.Title>
            <Block.Text>Manage client records in the system. Add a new client or modify existing client records</Block.Text>           
        </Block.HeadContent>
        <Block.HeadContent tools>
                            <div className="d-flex gap g-3 justify-content-center">                               
                                <div>
                                    <Button variant="primary" action="add" onClick={openAddModal}>
                                        <Icon name="plus"></Icon><span>New User</span>
                                    </Button>
                                </div>
                            </div>
                        </Block.HeadContent>     
    </Block.Head> */}


    <Block.Head>
            <Block.HeadBetween className="align-items-start">
                <Block.HeadContent>
                    <div className="d-flex flex-column flex-md-row align-items-md-center">                     
                        
                        <div className="mt-3 mt-md-0 ms-md-3">
                            <h3 className="title mb-1">Client (Service User) Management</h3>
                            <span className="small">Manage Service user records in the system. Add a new service user or modify existing service user records</span>
                        </div>
                        
                    </div>
                </Block.HeadContent> 
                <Block.HeadContent tools>
                    <div className="d-flex gap g-3 justify-content-center">                               
                        <div>
                            <Button variant="primary" action="add" onClick={openAddModal}>
                                <Icon name="plus"></Icon><span>New Client</span>
                            </Button>
                        </div>
                    </div>
                </Block.HeadContent>
            </Block.HeadBetween>
    </Block.Head>

    <DataTable tableClassName="data-table-head-light table-responsive" data={data} columns={tableColumns} expandableRowDisabled={true} filterFieldName="name" expandedComponent={expandedComponent}/>      
    </Layout>

    {showAddEdit && <AddEditClient show={showAddEdit} setShowAddEdit={setShowAddEdit} data={data} setdata={setdata}/>}

    </>
)
}


export default Clients